import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledTooltip  } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const PayAdjustments = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)

        const [sSelectedEmployee, setSSelectedEmployee] = useState(null)
        const [sScaleId, setSScaleId] = useState('')  
        const [sTitleId, setSTitleId] = useState('')
        const [sDeptId, setSDeptId] = useState('')
        const [sAdjustmentType, setSAdjustmentType] = useState('')
        const [sAdjustmentScope, setSAdjustmentScope] = useState('')
        const [sStatus, setSStatus] = useState('')

        const [adjustments, setAdjustments] = useState([])
        const [isEdit, setIsEdit] = useState(false)
    
        const [modal_adjustments, setmodal_adjustments] = useState(false);

        const [adjType, setAdjType] = useState(['Deduction', 'Addition'])
        const [adjCat, setAdjCat] = useState(['Tax', 'Contribution','Absence from duty', 'Allowance', 'Compensation','Bonus'])
        const [calcMethod, setCalcMethod] = useState(['Percent Gross', 'Percent Basic', 'Fixed', 'Range'])
        const [adjSco, setAdjSco] = useState(['Universal','Scale','Employee', 'Department','Title'])

        const [payGradesList, setPayGradesList] = useState([])
        const [rolesList, setRolesList] = useState([])
        const [depts, setDepts] = useState([])

        const [adjustmentScope, setAdjustmentScope] = useState('')
        const [jobTitleId, setJobTitleId] = useState('')
        const [selectedEmployee, setSelectedEmployee] = useState('')
        const [employeeOptions, setEmployeeOptions] = useState([])
        const [scaleId, setScaleId] = useState('')
        const [deptId, setDeptId] = useState('')
        const [entryId, setEntryId] = useState('')
        const [adjustmentNameOptions, setAdjustmentNameOptions] = useState(['Wadaada'])
        const [adjustmentName, setAdjustmentName] = useState('')
        const [adjustmentType, setAdjustmentType] = useState('')
        const [adjustmentCategory, setAdjustmentCategory] = useState('')
        const [calculationMethod, setCalculationMethod] = useState('') 
        const [percentageValue, setPercentageValue] = useState('')
        const [fixedAmount, setFixedAmount] = useState('')
        const [rangeData, setRangeData] = useState('')
        const [isActive, setIsActive] = useState('Yes')
        const [effectiveDate, setEffectiveDate] = useState([])
        const [endDate, setEndDate] = useState([])
        const [adjustmentDescription, setAdjustmentDescription] = useState('')
        const [daysAway, setDaysAway] = useState(0)
        const [userId, setUserId] = useState('')

        const employeeOptionsRef = useRef([]);

        const handleSaveUniversal = async () =>{
            const data = {
                id                  : isEdit?entryId:'',
                adjustment_scope    : adjustmentScope,
                employee_id         : adjustmentScope == 'Employee' && selectedEmployee?.value ? selectedEmployee.value : '',
                scale_id            : scaleId,
                dept_id             : deptId,
                title_id            : jobTitleId,
                adjustment_name     : adjustmentName,
                adjustment_type     : adjustmentType,
                adjustment_category : adjustmentCategory,
                calculation_method  : calculationMethod,
                percentage_value    : percentageValue,
                fixed_amount        : fixedAmount,
                days_away           : daysAway,
                range_data          : (calculationMethod == 'Range')? rangeData:'',
                is_active           : isActive,
                effective_date      : effectiveDate[0]?formatDate(effectiveDate):'',
                end_date            : endDate[0]?formatDate(endDate):'',
                adjustment_description         : adjustmentDescription,
                user_id             : userId,
                action              : isEdit?'update':'add'
    
            }
            setIsLoading(true)
            try {
                const r = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify(data), Config)
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_adjustments();
                    setEntryId('');setAdjustmentScope(''); setScaleId(''); setDeptId(''); setJobTitleId(''); setSelectedEmployee(null); setAdjustmentName(''); setAdjustmentType('');setAdjustmentCategory('')
                    setCalculationMethod('');setPercentageValue('');setFixedAmount('');setIsActive('Yes'); setDaysAway(0); setEffectiveDate([]);setEndDate([]);setAdjustmentDescription('');setIsEdit(false)
                    fetchData()
                }else{
                    toastr.error(r.data.message) 
                }
            } catch (e){
                console.log(e)
            } finally{
                setIsLoading(false)
            }
        }
        const handleDeleteAdjustment = async (id) =>{
            const data = {
                id                  : id,
                user_id             : userId,
                action              : 'delete'
            }
            setIsLoading(true)
            try {
                const r = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify(data), Config)
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message) 
                }
            } catch (e){
                console.log(e)
            } finally{
                setIsLoading(false)
            }
        }

        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_adjustments = () => {
          setmodal_adjustments(!modal_adjustments);
          removeBodyCss();
        }
        const fetchData = async () => {
            try {
                
                setIsLoading(true);
                const titlesResponse = await axios.get(url.TITLES, Config);
                setRolesList(titlesResponse.data);
                const deptsResponse = await axios.get(url.DEPTS, Config);
                setDepts(deptsResponse.data);
                const payScalesResponse = await axios.get(url.HRPAYSCALES, Config);
                setPayGradesList(payScalesResponse.data);
               
                const data = { id  : '', no  : '', nin : '', name: '', phone:'',sex : '', status:'Active', marital:'', dept: '', category: '', location: '' }
                const em = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(data), Config)
                let arr = []; (em.data || []).map((a)=>{ arr.push({'value':a.id, 'label':a.name}) })
                setEmployeeOptions(arr)
                employeeOptionsRef.current = arr; 
                
            } catch (error) {
                console.error("An error occurred while fetching data:", error);
            } finally {
                setIsLoading(false);
            }
            handleFilterData()
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
          }
          fetchData() 
        },[]);

        const handleFilterData = async () =>{
            const data = {
                employee_id : sSelectedEmployee?.value ? sSelectedEmployee.value : '',
                scale_id    : sScaleId,
                title_id    : sTitleId,
                dept_id     : sDeptId,
                adjustment_scope: sAdjustmentScope,
                adjustment_type : sAdjustmentType,
                is_active       : sStatus,
                action      : "filter"
            }
            setIsLoading(true);
            try {
                const uni = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify(data), Config)
                setAdjustments(uni.data)
            } catch (error) {
                console.error("An error occurred while fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
        const handleClearSearch = () =>{
          setSSelectedEmployee(null)
          setSScaleId('')
          setSTitleId('')
          setSDeptId('')
          setSAdjustmentScope('')
          setSAdjustmentType('')
          setSStatus('Yes')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          tog_adjustments()
          setEntryId('');
          setAdjustmentScope(''); 
          setScaleId(''); 
          setDeptId(''); 
          setJobTitleId(''); 
          setSelectedEmployee(null); 
          setAdjustmentName(''); 
          setAdjustmentType('');
          setAdjustmentCategory('')
          setCalculationMethod('');
          setPercentageValue('');
          setFixedAmount('');
          setIsActive('Yes');
          setEffectiveDate([]);
          setEndDate([]);
          setAdjustmentDescription('');
          setIsEdit(false)
        }
   
    
        const pageOptions = {
          sizePerPage: 10000,
          totalSize: adjustments.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'adjustment_scope',
          text: 'Sope',
          sort: true
        },
        {
          dataField: 'adjustment_type',
          text: 'Type',
          sort: true
        },
        {
          dataField: 'adjustment_category',
          text: 'Category',
          sort: true
        },
        {
          dataField: 'adjustment_name',
          text: 'Name',
          sort: true
        }, 

        {
          dataField: 'calculation_method',
          text: 'Method',
          sort: true
        }, 
        {
          dataField: 'created_at',
          text: 'Created On',
          sort: true
        }, 
        {
          dataField: 'is_active',
          text: 'Active',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'desc'
        }];
 
 
        function actionFormatter(cellContent, d){
          return(
            <div className="d-flex gap-3">
                <Link
                to="#"
                className="text-success"
                onClick={()=>{ 
                    setIsEdit(true); 
                    tog_adjustments(); 
                    setEntryId(d.id);
                    setAdjustmentScope(d.adjustment_scope); setScaleId(d.scale_id); setDeptId(d.dept_id); setJobTitleId(d.title_id); 
                    setSelectedEmployee(employeeOptionsRef.current.find(opt => parseInt(opt.value) == d.employee_id)); setAdjustmentName(d.adjustment_name); setAdjustmentType(d.adjustment_type);setAdjustmentCategory(d.adjustment_category);
                    setCalculationMethod(d.calculation_method);setPercentageValue(d.percentage_value);setFixedAmount(d.fixed_amount);setIsActive(d.is_active);
                    setRangeData(d.range_data);
                    setEffectiveDate((d.effective_date != '0000-00-00')?[new Date(d.effective_date)]:'');
                    setEndDate((d.end_date != '0000-00-00')?[new Date(d.end_date)]:'');setAdjustmentDescription(d.adjustment_description); }}
                >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                    Details
                </UncontrolledTooltip>
                </Link>
                <Link
                to="#"
                className="text-danger"
                onClick={() => handleDeleteAdjustment(d.id)}
                >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                </UncontrolledTooltip>
                </Link>
            </div>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Yes") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Pay Adjustments | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                            <Modal isOpen={modal_adjustments} toggle={() => { tog_adjustments()  }} size="xl" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Pay Adjustment` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_adjustments(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                  <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Scope</label>
                                            <select className="form-select" value={adjustmentScope} onChange={(e)=>setAdjustmentScope(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjSco || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    {(adjustmentScope == 'Department') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Department</label>
                                             <select className="form-select" value={deptId} onChange={(e)=>setDeptId(e.target.value)}>
                                                <option></option>
                                                {depts.map((d,k)=>(
                                                    <option key={k} value={d.id}>{d.name}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Title') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Job Title</label>
                                             <select className="form-select" value={jobTitleId} onChange={(e)=>setJobTitleId(e.target.value)}>
                                                <option></option>
                                                {rolesList.map((r,k)=>(
                                                    <option key={k} value={r.id}>{r.title}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Scale') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Pay Grade/Scale</label>
                                             <select className="form-select" value={scaleId} onChange={(e)=>setScaleId(e.target.value)}>
                                                <option></option>
                                                {payGradesList.map((d,k)=>(
                                                    <option key={k} value={d.id}>{d.name}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Employee') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Employee Name</label>
                                             <Select value={selectedEmployee} onChange={(oo)=>{setSelectedEmployee(oo);  }} options={employeeOptions} isSearchable/>
                                         </div>
                                        </Col>
                                    )}
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Name</label>
                                            <input type='text' className="form-control" value={adjustmentName} onChange={(e)=>setAdjustmentName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Adjustment Description</label>
                                            <textarea className="form-control" value={adjustmentDescription} onChange={(e)=>setAdjustmentDescription(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Type</label>
                                            <select className="form-select" value={adjustmentType} onChange={(e)=>setAdjustmentType(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjType || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Category</label>
                                            <select className="form-select" value={adjustmentCategory} onChange={(e)=>setAdjustmentCategory(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjCat || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                             
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Calculation Method</label>
                                            <select className="form-select" value={calculationMethod} onChange={(e)=>setCalculationMethod(e.target.value)} >
                                                <option value=''></option>
                                                  {(calcMethod || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    {['Percent Gross', 'Percent Basic'].includes(calculationMethod) && (
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Percentage value (0 - 100)</label>
                                                <input type='number' className="form-control" value={percentageValue} onChange={(e)=>setPercentageValue(e.target.value)} />
                                            </div>
                                        </Col>
                                    )}
                                    {['Fixed'].includes(calculationMethod) && (
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Fixed Amount</label>
                                            <input type='number' className="form-control" value={fixedAmount} onChange={(e)=>setFixedAmount(e.target.value)} />
                                        </div>
                                    </Col>
                                    )}
                                    {['Range'].includes(calculationMethod) && (
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Range </label>
                                            <textarea className="form-control" rows={4} value={rangeData} onChange={(e)=>setRangeData(e.target.value)} />
                                        </div>
                                    </Col>
                                    )}
                                    </Row>
                                    <Row> 
                                    <Col xl={4}>
                                            <div className="mb-3">
                                                <label>Is Active</label>
                                                <select className="form-select" value={isActive} onChange={(e)=>setIsActive(e.target.value)}>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            </div>
                                        </Col>                                   
                                        <Col xl={4}>
                                        <div className="mb-3">
                                            <label>Start Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={effectiveDate}
                                                onChange={(dates)=>{setEffectiveDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={4}>
                                        <div className="mb-3">
                                            <label>End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={endDate}
                                                onChange={(dates)=>{setEndDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                         
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_adjustments() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveUniversal}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>


                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
 
                                                <Row className="justify-content-center mb-2">
                                                <Col md={4}>
                                                      <div className="mb-3">
                                                          <label>Employee</label>
                                                          <Select value={sSelectedEmployee} onChange={(oo)=>{setSSelectedEmployee(oo);  }} options={employeeOptions} isSearchable/>
                                                      </div>
                                                  </Col>
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Adjustment Scope</label>
                                                          <select className="form-select" value={sAdjustmentScope} onChange={(e)=>setSAdjustmentScope(e.target.value)} >
                                                                <option value=''>All</option>
                                                                {(adjSco || []).map((t,k)=>(
                                                                    <option key={k} value={t}>{t}</option>
                                                                ))}
                                                            </select>
                                                      </div>
                                                  </Col>
                                                    <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Adjustment Type</label>
                                                          <select className="form-select" value={sAdjustmentType} onChange={(e)=>setSAdjustmentType(e.target.value)} >
                                                                <option value=''>All</option>
                                                                {(adjType || []).map((t,k)=>(
                                                                    <option key={k} value={t}>{t}</option>
                                                                ))}
                                                            </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Pay Grade/Scale</label>
                                                          <select className="form-select" value={sScaleId} onChange={(e)=>setSScaleId(e.target.value)}>
                                                                <option>All</option>
                                                                {payGradesList.map((d,k)=>(
                                                                    <option key={k} value={d.id}>{d.name}</option>
                                                                ))}
                                                            </select>
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Job Title</label>
                                                          <select className="form-select" value={sTitleId} onChange={(e)=>setSTitleId(e.target.value)}>
                                                            <option>All</option>
                                                            {rolesList.map((r,k)=>(
                                                                <option key={k} value={r.id}>{r.title}</option>
                                                            ))}
                                                        </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Department</label>
                                                          <select className="form-select" value={sDeptId} onChange={(e)=>setSDeptId(e.target.value)}>
                                                            <option value="">All</option>
                                                            {depts.map((d,k)=>(
                                                                <option key={k} value={d.id}>{d.name}</option>
                                                            ))}
                                                        </select>
                                                      </div>
                                                  </Col>
                                               
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Is Active</label>
                                                          <select className="form-select" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="Yes">Yes</option>
                                                              <option value="No">No</option>
                                                          </select>
                                                      </div>
                                                  </Col>
                                          
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Pay Adjustment
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Pay Adjustments ({adjustments.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(adjustments.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={adjustments}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ adjustments }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='id' 
                                                  data={ adjustments } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                 
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((adjustments || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No pay Adjustments</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Add Pay Adjustments <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PayAdjustments;